import React, { useMemo } from 'react';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import appConfig from '../../../../../../app-config';
import { CircularProgressLocal } from '../../../../../components/Progress/CircleProgressLocal';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  height: 289px !important;
  width: 434px;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 5px 16px 0 rgba(66, 59, 112, 0.32);
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 25px;
  cursor: ${(props) => (props.layoutStyle === 'offer' ? 'default' : 'pointer')};

  &:hover {
    box-shadow: 0 2px 7px 0 rgba(66, 59, 112, 0.24);
    transition: all 0.25s ease;
  }
  @media (max-width: 1550px) {
    width: ${(props) => (props.fullWidth ? '100%' : '314px !important')};
    height: ${(props) =>
      !props.isOfferPage ? '215px !important' : '289px !important'};
  }
  @media (max-width: 750px) {
    width: 100% !important;
    height: 240px !important;
  }
`;

const DetailsDiv = styled.div`
  position: absolute;
  top: 38%;
  left: 20px;
  color: ${(props) => props.textColor};
`;

const Logo = styled.div`
  position: absolute;
  top: 20%;
  right: 20px;
  @media (max-width: 1550px) {
    right: ${(props) => (props.isOfferPage ? '20px' : '5px')};
  }
`;

const Label = styled.div`
  font-size: 14px;
  color: ${(props) => props.textColor};
`;

const Title = styled.span`
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 16px;
  color: #000000;
  background-color: #ffffff;
  padding: 5px 20px;
  border-radius: 18px;
  font-weight: 500;
  @media (max-width: 750px) {
    top: 12px;
    left: 12px;
    font-size: 14px;
  }
`;
const BalanceText = styled.div`
  font-size: 14px;
  color: ${(props) => props.textColor};
  font-weight: 500;
`;

const BalanceSpan = styled.span`
  font-size: 22px;
  color: ${(props) => props.textColor};
  @media (max-width: 1200px) {
    font-size: 18px;
  }
`;

const NextTierMessage = styled.div`
  font-size: 16px;
  color: ${(props) => props.textColor};
  max-width: ${(props) => (props.isMobile ? '200px' : '100%')};
  margin-top: 10px;
  @media (max-width: 1550px) {
    margin-top: ${(props) => (props.isOfferPage ? '10px' : '4px')};
    font-size: ${(props) => (props.isOfferPage ? '16px' : '14px')};
  }
`;
const NextOfferMessage = styled.span`
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: ${(props) => props.textColor};
  font-size: 15px;
  font-weight: 500;

  @media (max-width: 1550px) {
    font-size: ${(props) => (props.isOfferPage ? '15px' : '13px')};
    bottom: ${(props) => (props.isOfferPage ? '20px' : '10px')};
  }
`;

const KintonLoyaltyCard = ({ layoutStyle, loyalty }) => {
  const { t, i18n } = useTranslation();
  const { offers } = useSelector((state) => state?.offersReducer) || {};
  const isOfferPage = window.location.pathname.includes('offers');
  const isMobile = window.innerWidth <= 1550;
  let { loyalty_details, tier_details } = loyalty;
  const balance = loyalty_details.details.lifetime_points_earned;
  const { loyaltyTierDetails, loyaltyTierNameStyle } = appConfig;

  const selectedConfig = useMemo(() => {
    if (!tier_details) {
      return loyaltyTierDetails?.find((tier) => tier.id === 'Silver');
    }
    return loyaltyTierDetails?.find(
      (tier) =>
        tier.id === tier_details?.name ||
        tier.idFr === tier_details?.name ||
        (tier_details?.name === undefined && tier.id === 'Silver'),
    );
  }, [tier_details, loyaltyTierDetails]);
  console.log('loyalty', loyalty);

  const pointsToNextTier = tier_details?.next_tier_points - balance;

  const nextTireName = tier_details?.next_tier_name || '';
  const isTopTier = ['Legend', 'Légende'].includes(tier_details?.name);

  const currentPointBalance = loyalty_details?.details?.current_points_balance;

  const progressInPercent = useMemo(() => {
    if (isTopTier) {
      return 100;
    }
    if (tier_details?.progress_to_next_tier) {
      return tier_details?.progress_to_next_tier;
    } else {
      return 0;
    }
  }, [isTopTier, tier_details, pointsToNextTier]);

  const nextOfferMessage = useMemo(() => {
    console.log('offers', offers);
    const foundPointsOffer = offers?.find((offer) => offer?.cost > 0);
    console.log('foundPointsOffer', foundPointsOffer);
    const availablePointCost =
      loyalty_details?.details?.next_offer?.data?.offer_details?.points_cost ||
      foundPointsOffer?.cost;

    console.log('availablePointCost', availablePointCost);
    //
    const pointsToNextOffer =
      availablePointCost !== undefined && currentPointBalance !== undefined
        ? availablePointCost - (currentPointBalance % availablePointCost)
        : null;
    ///

    const y = Math.floor(currentPointBalance / availablePointCost);
    console.log('pointsToNextOffer', pointsToNextOffer);
    console.log('y', y);
    if (
      availablePointCost === undefined ||
      availablePointCost === null ||
      availablePointCost === 0
    ) {
      return null;
    }
    return (
      <div>
        <div>
          {t('rewards.moreBowlTo', {
            pointsToNextOffer: pointsToNextOffer,
            nextOffer:
              loyalty_details?.details?.next_offer?.data?.title ||
              t('rewards.freeAppetizer'),
            unit:
              pointsToNextOffer > 1 ? t('rewards.bowls') : t('rewards.bowl'),
          })}
        </div>
        {y > 0 && (
          <div>
            {t('rewards.moreBowlTo2', {
              freeAppetizerQty: y,
              unit: y > 1 ? t('rewards.appetizers') : t('rewards.appetizer'),
            })}
          </div>
        )}
      </div>
    );
  }, [isTopTier, loyalty_details, t, offers]);

  return (
    <Wrapper
      fullWidth={layoutStyle === 'offer'}
      onClick={() => navigate('/offers')}
      backgroundImage={selectedConfig?.backgroundImage}
      layoutStyle={layoutStyle}
      isOfferPage={isOfferPage}
    >
      <Title
        id='LoyaltyCard-BalanceDetails'
        textColor={selectedConfig?.textColor}
      >
        {`Kinton Bowler ${tier_details?.name}`}
      </Title>
      <DetailsDiv textColor={selectedConfig?.textColor}>
        <Label textColor={selectedConfig?.textColor}>
          {t('rewards.lifetimeBowls')}:
        </Label>
        <BalanceText
          id='LoyaltyCard-BalanceDetails'
          textColor={selectedConfig?.textColor}
        >
          <BalanceSpan textColor={selectedConfig?.textColor}>
            {balance}{' '}
          </BalanceSpan>
          <BalanceSpan textColor={selectedConfig?.textColor}>
            {balance > 1 ? t('rewards.bowls') : t('rewards.bowl')}
          </BalanceSpan>
          <NextTierMessage
            textColor={selectedConfig?.textColor}
            isMobile={
              isMobile &&
              (!isOfferPage || (isOfferPage && window.innerWidth < 750))
            }
            isOfferPage={isOfferPage}
          >
            {isTopTier
              ? t('rewards.congratsMessage')
              : t('rewards.unlockNextTierIn', {
                  nextTier: nextTireName,
                  pointsToNextTier: pointsToNextTier,
                  unit:
                    pointsToNextTier > 1
                      ? t('rewards.bowls')
                      : t('rewards.bowl'),
                })}
          </NextTierMessage>
        </BalanceText>
      </DetailsDiv>
      {nextOfferMessage && (
        <NextOfferMessage
          textColor={selectedConfig?.textColor}
          isOfferPage={isOfferPage}
        >
          {nextOfferMessage}
        </NextOfferMessage>
      )}
      <Logo isOfferPage={isOfferPage}>
        <CircularProgressLocal
          size={isMobile && !isOfferPage ? 100 : 115}
          strokeWidth={6}
          progress={progressInPercent}
          trackColor={'#ffffff'}
          progressColor={selectedConfig?.progressBarColor}
        >
          <img
            src={selectedConfig?.logo}
            width='initial'
            style={{ width: '102%' }}
          />
        </CircularProgressLocal>
      </Logo>
    </Wrapper>
  );
};

export default KintonLoyaltyCard;
